<template>
	<div v-if="ratingsForm.stars && ratingsForm.stars !== ''" class="google-reviews">
		<GlobalIcon name="google-icon" :width="16" />
		<div class="google-reviews__divider"></div>
		<div class="google-reviews__container">
			<div class="google-reviews__stars">
				<GlobalRating
					:rating="ratingsForm.stars"
					readonly
					colorFilled="var(--primary-color)"
					colorEmpty="var(--primary-color)"></GlobalRating>
			</div>
			<p class="google-reviews__text">
				{{ ratingsForm.ratings }},
				<a :href="ratingsForm?.url" target="_blank" class="google-reviews__link">
					{{ ratingsForm.ratingsCount }} {{ $t('components.booker.google_reviews.opinions') }}
				</a>
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
const googleRatingsStore = useGoogleRatingsStore()

const ratingsForm = reactive({
	stars: '',
	ratings: '',
	ratingsCount: '',
	url: '',
})

await googleRatingsStore.fetchGoogleRating()

watch(
	() => googleRatingsStore.getGoogleRating,
	(v) => {
		if (v) {
			ratingsForm.stars = v.stars
			ratingsForm.ratings = v.ratings
			ratingsForm.ratingsCount = v.ratingsCount
			ratingsForm.url = v.url
		}
	},
	{ immediate: true },
)
</script>

<style scoped lang="scss">
@import './GoogleReviews.scss';
</style>
